import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayCategory } from "../models/CatalogCategory";

type getCatalogCategoriesProps = {
	includeInactives: boolean;
	delayAreaAssetId?: number | null;
	includeAncestor?: boolean;
};

export const getCatalogCategories = async (
	params: getCatalogCategoriesProps,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "IncludeInactive", value: params.includeInactives },
	];

	if (params.delayAreaAssetId)
		parameters.push({
			name: "DelayAreaAssetId",
			value: params.delayAreaAssetId,
		});
	if (params.includeAncestor)
		parameters.push({ name: "IncludeAncestor", value: params.includeAncestor });

	const resp = await apiService.callV2(
		"[DEL].[GetDelayCategories]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayCategory[];
	} else {
		throw new Error(resp.message || "Error fetching categories");
	}
};

export const deleteCatalogCategory = async (delayCategoryId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "DelayCategoryId", value: delayCategoryId },
	];

	const resp = await apiService.callV2(
		"[DEL].[DeleteDelayCategory]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting category");
	}
};

export const upsertCatalogCategory = async (category: DelayCategory) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "DelayCategoryId", value: category.DelayCategoryId },
		{
			name: "DelayCategoryName",
			value: category.DelayCategoryName,
		},
		{ name: "DelayCategoryColor", value: category.DelayCategoryColor },
		{ name: "IsActive", value: category.IsActive },
	];

	const resp = await apiService.callV2(
		"[DEL].[UpsertDelayCategory]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error upserting category");
	}
};
